class PromotionalBar extends HTMLElement {
  constructor() {
    super();
    this.bar = null;
    this.slides = [];
    this.closeBtn = null;
    this.storageKey = null;
    this.observer = null;
    this.abortController = new AbortController();
    this.currentIndex = 0;
    this.cycleTimer = null;
  }

  connectedCallback() {
    const sectionId = this.dataset.sectionId;
    this.storageKey = `promo-bar-closed-${sectionId}`;

    if (sessionStorage.getItem(this.storageKey)) {
      this.setPromoHeight(0);
      this.remove();
      return;
    }

    this.bar = this.querySelector('.eyda-promo-bar');
    this.slides = [...this.querySelectorAll('[data-promo-slide]')];
    this.closeBtn = this.querySelector('[data-promo-close]');

    if (!this.bar || !this.slides.length) return;

    this.updatePromoHeight();
    this.observeVisibility();
    this.initCycle();

    this.closeBtn?.addEventListener('click', () => this.close(), {
      signal: this.abortController.signal,
    });
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.observer?.disconnect();
    clearTimeout(this.cycleTimer);
    this.setPromoHeight(0);
  }

  initCycle() {
    if (this.slides.length === 1) {
      this.slides[0].classList.add('opacity-100');
      this.slides[0].classList.remove('pointer-events-none');
      return;
    }
    this.showSlide(0);
  }

  showSlide(index) {
    const speed = parseFloat(this.bar.dataset.marqueeSpeed) || 60;
    // Higher speed = shorter display time. speed=60 → ~5s, speed=200 → ~1.5s, speed=20 → ~15s
    const displayDuration = 300000 / speed;
    const fadeDuration = 500;

    this.slides[index].classList.add('opacity-100');
    this.slides[index].classList.remove('pointer-events-none');

    this.cycleTimer = setTimeout(() => {
      this.slides[index].classList.remove('opacity-100');
      this.slides[index].classList.add('pointer-events-none');
      setTimeout(() => {
        const next = (index + 1) % this.slides.length;
        this.showSlide(next);
      }, fadeDuration);
    }, displayDuration);
  }

  setPromoHeight(px) {
    document.documentElement.style.setProperty('--promo-bar-height', `${px}px`);
  }

  updatePromoHeight() {
    this.setPromoHeight(this.bar.offsetHeight);
  }

  observeVisibility() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.setPromoHeight(entry.isIntersecting ? this.bar.offsetHeight : 0);
      },
      { threshold: 0 }
    );
    this.observer.observe(this.bar);
  }

  close() {
    sessionStorage.setItem(this.storageKey, 'true');
    clearTimeout(this.cycleTimer);
    this.setPromoHeight(0);
    this.bar.classList.add('eyda-promo-bar--closing');
    this.bar.addEventListener('transitionend', () => this.remove(), {
      once: true,
      signal: this.abortController.signal,
    });
  }
}

if (!customElements.get('promotional-bar')) {
  customElements.define('promotional-bar', PromotionalBar);
}
